import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const CookiesConsent = () => {
  const [showConsent, setShowConsent] = useState(true);

  const acceptCookies = () => {
    setShowConsent(false);
    localStorage.setItem('cookiesAccepted', 'true');
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div className="cookies_component">
      <div className="padding-global">
        <div className="container-large">
          <div className="cookie-card_wrapper">
            <div className="cookie-card">
              <div>Usamos cookies para melhorar a experiência no nosso site. Consulta a nossa política de privacidade.</div>
              <div className="button-group-cookies">
                <a href="#" className="button is-small w-button" onClick={acceptCookies}>Accept</a>
                <Link to="/policies/privacy-policy" className="button is-small w-button">Cookie Settings</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesConsent;